import {makeRequest, getRequest} from './base';
import {store} from '@/store';

const fake = false;

export function faces() {
  return makeRequest('/api/v5/faces');
}

export function facesdetected() {
  return makeRequest('/api/v4/facesdetected');
}

export function faceimage(face_uuid) {
  return makeRequest('/api/v4/faceimage', {face_uuid});
}

export function facematches(runtime_face_uuid) {
  return makeRequest('/api/v4/facematches', {runtime_face_uuid});
}

export function facesearch(frontend_face_uuid) {
  return makeRequest('/api/v4/facematches', {frontend_face_uuid});
}

export function faceconfirm(runtime_face_uuid, is_face) {
  return makeRequest('/api/v4/faceconfirm', {runtime_face_uuid, is_face});
}

export function facematchconfirm(runtime_face_uuid, frontend_face_uuid, is_correct) {
  return makeRequest('/api/v4/facematchconfirm', {runtime_face_uuid, frontend_face_uuid, is_correct});
}

export function facesdetected2(frontend_face_uuid, refresh_token) {
  const params = {
    frontend_face_uuid,
    refresh_token,
    min_face_height: store.getters.minFaceHeight,
    domain_uuid: store.getters.domainUUID,
  }
  return makeRequest('/api/v5/facesdetected2', params)
}

export function facesconfirmed(offset = 0) {
  return makeRequest('/api/v4/faces/confirmed', {offset});
}

export function facevisitor(runtime_face_uuid) {
  return makeRequest('/api/v4/faces/visitor', {runtime_face_uuid});
}

export function facesmatched(which_results) {
  let req_str = `which_results=${which_results}` ;
  const min_face_height = store.getters.minFaceHeight
  const domain_uuid = store.getters.domainUUID
  if (min_face_height) {
    req_str += `&min_face_height=${min_face_height}`
  }
  if (domain_uuid) {
    req_str += `&domain_uuid=${domain_uuid}`
  }
  return getRequest('/api/v6/faces/matched', req_str);
}

export function facestrainingmodels() {
  if (fake) {
    return new Promise((resolve, reject) => {
        resolve({
          data: {
            ok: true,
            models: [
              {
                "name": "feb1_exp0/v0"
              },
              {
                "name": "feb5_exp3/v2"
              }
            ]
          }
        })
      })
  }
  return getRequest('/api/v6/faces/training/models', '');
}

export function facestrainingresults(model_list) {
  if (fake) {
    return new Promise((resolve, reject) => {
      const toret = {
        data: {
          "ok": true,
          "results": [
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:06:07 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8842412233352661,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7230885028839111,
                          "model_name": "feb5_exp3/v2"
                      },
                        {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7230885028839111,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "a603863b-0abf-4a0c-80ce-1c2d4e4e399d"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:06:07 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8629486560821533,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8782356381416321,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "45d8e331-143d-43c6-9053-21037a702990"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:07 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7fff2082-ebc3-46e5-9999-3d1e1c2674ca",
                          "match_confidence": 0.5186018347740173,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7fff2082-ebc3-46e5-9999-3d1e1c2674ca",
                          "match_confidence": 0.7989897131919861,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "9a24d3ba-3714-471d-9942-d602617c88ed"
              },
              {
                  "camera_description": "West-2: Entering Elevators",
                  "captured_at": "Wed, 07 Feb 2018 05:06:06 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.2695680856704712,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "f7bd20aa-93b5-489f-ab84-f4910e0a14a0",
                          "match_confidence": 0.356876015663147,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "9f94cac4-e1f5-4cbc-99ae-99fb10cb5a5b"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:06 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.7738505005836487,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9547277092933655,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "dfa7545c-f8b0-4c48-80a3-b6cf8a427b2a"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:05 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9680680632591248,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9660554528236389,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "1097a149-45f3-42a4-89fe-4121320089e3"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:05 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7fff2082-ebc3-46e5-9999-3d1e1c2674ca",
                          "match_confidence": 0.37851664423942566,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7fff2082-ebc3-46e5-9999-3d1e1c2674ca",
                          "match_confidence": 0.5706501007080078,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "6aeceaf8-4f88-4cdb-9f5d-91c6ace739f5"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:04 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "fb786211-614c-47da-916f-363769e9ab32",
                          "match_confidence": 0.5005820393562317,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "fb786211-614c-47da-916f-363769e9ab32",
                          "match_confidence": 0.7523999810218811,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "755b57ba-0412-4895-b3fd-2b9be11bee57"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:04 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.8884806632995605,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.6535124778747559,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "337f91a0-7074-413c-a0a5-607529d0a7ad"
              },
              {
                  "camera_description": "West-2: Entering Elevators",
                  "captured_at": "Wed, 07 Feb 2018 05:06:03 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "2f7e757a-56bc-4483-aac7-d79364e5e723",
                          "match_confidence": 0.267816960811615,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "fb786211-614c-47da-916f-363769e9ab32",
                          "match_confidence": 0.3248794972896576,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b92d89b6-1bd9-41c4-b32b-0b46d9d4aba1"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:03 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7fff2082-ebc3-46e5-9999-3d1e1c2674ca",
                          "match_confidence": 0.5159524083137512,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7fff2082-ebc3-46e5-9999-3d1e1c2674ca",
                          "match_confidence": 0.4101608991622925,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "350685f8-9e1d-450a-afb0-8b309ae938b7"
              },
              {
                  "camera_description": "West-2: Entering Elevators",
                  "captured_at": "Wed, 07 Feb 2018 05:06:02 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.5334944725036621,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.8759841322898865,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "ff65d9af-9e36-4514-bb81-0fa130674071"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:06:02 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9911086559295654,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8012120723724365,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "75f35c0a-17cd-485c-b682-ff03e86d83ff"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:02 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.6322402358055115,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7fff2082-ebc3-46e5-9999-3d1e1c2674ca",
                          "match_confidence": 0.7177585363388062,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "e022041f-fabb-402a-92cf-a17e0f6c2e9d"
              },
              {
                  "camera_description": "West-2: Entering Elevators",
                  "captured_at": "Wed, 07 Feb 2018 05:06:01 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.44948118925094604,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "2f7e757a-56bc-4483-aac7-d79364e5e723",
                          "match_confidence": 0.8199079632759094,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "abec8da0-ae63-47db-ab43-118d64f95e25"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:01 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9321454167366028,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.869953989982605,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b761df90-bf42-46d6-be44-a010aeab9b46"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:06:00 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.867475688457489,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.7427988648414612,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "0511e2b9-df93-446f-a420-df07fcb1bae0"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:05:59 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "b0e990a2-cf4f-4a10-82bf-2ba2931d0689",
                          "match_confidence": 0.41227492690086365,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.4762471616268158,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "6bba54b6-39f2-4688-9bdf-76709a6c467e"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:05:58 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.996259331703186,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9979827404022217,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "cbfc5826-4836-47ec-882c-db385e56ceec"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:57 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "25ad8b62-1fcc-4ec3-b264-72d72f20f270",
                          "match_confidence": 0.6184220910072327,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "88565baa-9a88-45bd-a1c4-c69f1d706c95",
                          "match_confidence": 0.19631364941596985,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b9e257e2-0e9a-484a-b953-acd8997279c8"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:05:57 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9729740023612976,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9329955577850342,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b9077905-8caa-450b-b0ec-0858408c7f72"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:56 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9317018389701843,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.7624808549880981,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "55463db1-c3b9-4546-86fc-96c1a3e18a80"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:55 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9997289776802063,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9996932744979858,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "913f6655-c898-475b-b197-ec27f1a44d6f"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:54 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.4346824884414673,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "83b89c16-0b17-4534-b2c2-7efdb623b451",
                          "match_confidence": 0.8156570792198181,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "372b1b61-ea6b-489c-a792-f2a8204c85de"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:52 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7812dc19-7be9-44bf-96cb-38f1add6d7bc",
                          "match_confidence": 0.5626355409622192,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7812dc19-7be9-44bf-96cb-38f1add6d7bc",
                          "match_confidence": 0.5116567015647888,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "1d3f7e3f-535b-47a1-b196-363df70a6f42"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:50 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.995281994342804,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9769294857978821,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "f4ba9498-7901-41dc-8538-1a2012f1397b"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:49 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9756331443786621,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8879668116569519,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "3f189d90-e2ed-4d32-814d-37ce7bdaec71"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:48 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "f34b436a-1b36-4c10-b422-184058b9c8c0",
                          "match_confidence": 0.414007306098938,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.5358268618583679,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "3d10e616-9f5d-44f0-a3b7-d11b0fe39012"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:45 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.7675350904464722,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.7040926814079285,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "db4941ae-4a36-494c-858e-573a6d1cd374"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:43 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "fb786211-614c-47da-916f-363769e9ab32",
                          "match_confidence": 0.3647851049900055,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "a22f0b13-45e5-4262-8d6a-650e05a86374",
                          "match_confidence": 0.5341604948043823,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "06b89bdf-2a85-4c31-b9d2-25ccbb6f424e"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:42 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "332a5b2d-92e8-494d-b0c5-5ecf92c81547",
                          "match_confidence": 0.7817150354385376,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.948552131652832,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "5faf2ba3-8f76-47b4-86bf-07ec1e7b5252"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:41 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "dcab5b57-f109-4c86-84d6-2406a3137c2b",
                          "match_confidence": 0.9957029223442078,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "dcab5b57-f109-4c86-84d6-2406a3137c2b",
                          "match_confidence": 0.9382982850074768,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "066309ce-6cf1-4c0d-8af4-8e67469b6383"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:40 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "a22f0b13-45e5-4262-8d6a-650e05a86374",
                          "match_confidence": 0.6112890839576721,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "a22f0b13-45e5-4262-8d6a-650e05a86374",
                          "match_confidence": 0.3376852571964264,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "d34aa473-0ddf-46f7-9949-9d174d0d6ea2"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:39 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.9940223097801208,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.9854335784912109,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "c4b8b7f6-09ab-4740-b6b3-35f160bc7eaa"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:38 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.9877049922943115,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.986377477645874,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "24cba3db-cce8-4ec0-b54b-b7c3fe82f538"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:37 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.4269447922706604,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.7433467507362366,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "d19f9d1f-7dda-4fba-ad4f-176b61f1ae37"
              },
              {
                  "camera_description": "West-2: Exiting Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:05:35 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.5277500748634338,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.8599663376808167,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "31ae1ba1-48f9-4f47-a1b7-a2fb78f9193c"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:28 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.6324313282966614,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.930372953414917,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "9e85f507-4aac-462a-af9e-e16f0bc7d6e4"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:26 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.4861587584018707,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8223518133163452,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "4ae3dcc3-270f-4ca0-840c-c3386db20dd1"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:23 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8463684916496277,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.4723809063434601,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "5556a848-28f4-457e-b7d9-aa414e618600"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:23 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "2030fccc-c4a2-4aa3-905c-b6912ca3e6d9",
                          "match_confidence": 0.6786932349205017,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "2030fccc-c4a2-4aa3-905c-b6912ca3e6d9",
                          "match_confidence": 0.949834406375885,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "f68d5e43-bc9b-4666-9fd3-e2e64889902a"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:22 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.631057620048523,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7206510901451111,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "faa587d4-c7b5-47ca-b109-30cc729ddbaf"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:21 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8745651841163635,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9435946345329285,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "cd1821b3-f769-41d1-9cfb-c3bcc738d549"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:20 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "43adec41-2f89-4b0b-a00a-c01de3611f58",
                          "match_confidence": 0.45002055168151855,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.6689876317977905,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "93abed30-bf3b-412e-83ed-3bce422e178b"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:19 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9583953022956848,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.930671751499176,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "337857a2-5073-421b-9055-ff9e3ccdb66d"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:18 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7342506051063538,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.4838370382785797,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "891eef3b-b214-4a30-ac1d-2c737a044230"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:18 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.22128966450691223,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.3744122385978699,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "709cc782-09b0-420a-848e-c635eb0b3339"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:17 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9612205028533936,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9523271322250366,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "528c0abd-a4e9-4840-b7c5-d36bdb7d586c"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:16 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "cfdcf499-3204-4b2c-85fe-9b4bf7e96608",
                          "match_confidence": 0.4724295735359192,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.552067220211029,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "bd0bc5c7-f13c-4a75-ad0e-a28e39aedd72"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:15 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8015967607498169,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.5755837559700012,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "6795464b-8cfd-47ac-815f-eecb13d93cfa"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:08 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8046426177024841,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8241304755210876,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "4b13fb13-9ce7-4b24-9165-a7749641bfbd"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:07 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9171323776245117,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.5255298018455505,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "8cb9e919-a8f6-4233-bda2-e92508732cc5"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:06 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9458205103874207,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9832707047462463,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "d5b3cef0-2b34-4c63-93bc-72a24c9ec663"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:05 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9564192891120911,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.6114392280578613,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b1f80713-be5a-4942-a87b-2a5607451245"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:04 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "c2d394e2-e676-4d61-8c41-a2b893e587ef",
                          "match_confidence": 0.5459418892860413,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.6477352976799011,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "e1d09dd4-ee57-4b8d-a7fc-706217349983"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:04 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9470740556716919,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.951370358467102,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "905bc948-7935-4ec5-8985-7590ce1f79cd"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:03 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.67046058177948,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9123623371124268,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "c873c25f-ee8d-4a08-a714-1b2eb5cedae1"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:05:02 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9194496273994446,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.4902343153953552,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "5b680bc1-6704-43ff-8d8f-35b0526e3c48"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:53 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9398667812347412,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9695101380348206,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "02f743c7-dc7d-46c6-bce3-f9cc7346c502"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:52 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9854506254196167,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9650015830993652,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "1ad2edaa-b1cf-4eda-a8b5-9646da8b07d5"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:51 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.5251997709274292,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.6519485712051392,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "cfc5b661-16c8-4fb1-bd4c-a0871818e8f6"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:50 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9855660796165466,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9374779462814331,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "e93b28b4-e81f-457c-b7dd-9beadbbc05c4"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:48 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.4444894790649414,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.5909129977226257,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "9ee642ba-dfec-494c-92d3-6be83a69f632"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:47 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7428231239318848,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8082883358001709,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "98ac6f80-6be0-4a47-bf12-25a90e9fec80"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:46 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8689577579498291,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9323402047157288,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "fe050132-d79f-4ff6-9ad3-3f57c8de19ba"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:45 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7269442081451416,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.4447585940361023,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "00b91a7f-575f-462f-95e2-d3018f6c7215"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:44 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.5590744018554688,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.5506681799888611,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "7009b338-4090-4260-a472-e9d644bd9892"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:43 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7255397439002991,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.45503947138786316,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "80e06692-6447-4d14-984d-512392b8ab43"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:42 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.4681425094604492,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.4627992808818817,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "573a8872-e68b-4084-a895-8404384e13a0"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:41 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.726304829120636,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7836912870407104,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "5e290f2b-8bc8-4078-96fb-c026e20a5232"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:04:41 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9938807487487793,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9994310736656189,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "fc9ce7c8-afe4-4168-af74-9f06cb097e30"
              },
              {
                  "camera_description": "Lobby Exit North (ER)",
                  "captured_at": "Wed, 07 Feb 2018 05:04:40 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.5449753403663635,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "664ce3cb-7e77-442e-9692-b5c47ebf4d56",
                          "match_confidence": 0.9817196726799011,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "23ea87ac-6fe7-4122-84d2-86ea3efc9cf4"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:40 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.5081424713134766,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.7188960313796997,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "38784472-b133-4b3e-9d4d-af0d836fdc45"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:38 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.5567580461502075,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.8933015465736389,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "f8b9e313-979a-418a-a951-0bc20c74e44a"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:36 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9529712796211243,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9826186895370483,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "15cffa76-5af8-49f2-88e0-9ce087c457b3"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:35 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8765313029289246,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7806726694107056,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "c8866134-726b-4894-b44d-622ec508555e"
              },
              {
                  "camera_description": "West-2: End Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:32 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "77db6438-645c-49f3-9d36-772bfc8bb1d8",
                          "match_confidence": 0.5997658967971802,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "285c7044-40bc-4ad2-9bd3-8087485e86f0",
                          "match_confidence": 0.3562757968902588,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "14cda08e-1ff7-4712-8472-7df49d73d9ae"
              },
              {
                  "camera_description": "West-2: End Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:31 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.831072986125946,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.944976806640625,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "57040359-5d70-40df-a93f-272a8da2a0c1"
              },
              {
                  "camera_description": "West-2: End of Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:30 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.6876275539398193,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.4817698299884796,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b160ab06-5964-4d28-b8b1-714f86a201f5"
              },
              {
                  "camera_description": "West-2: End Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:30 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.9948556423187256,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.9957363605499268,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "7f833f49-a38b-40b9-ad0d-1eba32b870db"
              },
              {
                  "camera_description": "West-2: End Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:29 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.7885021567344666,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7994ddfe-855a-46a0-9097-bfd9bec4e9d2",
                          "match_confidence": 0.9641528725624084,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "99639699-1439-4887-8353-0e0e52e81302"
              },
              {
                  "camera_description": "West-2: End of Left Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:22 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8597419261932373,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7600234150886536,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "ac30880f-9977-415f-bf99-860d0742d439"
              },
              {
                  "camera_description": "West-2: End Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:13 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.49964457750320435,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.6699488162994385,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "faa019d6-9e73-415f-9dd9-7dc4b68432f5"
              },
              {
                  "camera_description": "West-2: End Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:04:12 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8150345087051392,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7153099775314331,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "1d70835a-79d7-4b63-b10d-f3b644dceebe"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:04:04 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "740ab8c4-cad3-4241-8c42-287c79b2f6ec",
                          "match_confidence": 0.6364957690238953,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.7158594131469727,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "c7f6e6d1-c9af-44aa-a656-6a127bb3f93d"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:54 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "d90ea080-231c-4116-97e7-be0eb1a9077e",
                          "match_confidence": 0.8840199112892151,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "d90ea080-231c-4116-97e7-be0eb1a9077e",
                          "match_confidence": 0.5725005865097046,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b82c1657-3c8c-442a-bb75-1f2a936b98c6"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:45 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9830818772315979,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9944615960121155,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "fad3bf50-6fa0-4107-9165-88a43892e98f"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:03:44 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.9388045072555542,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8854524493217468,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "9b7bd4e8-b95b-4998-b231-bcf2789fa8da"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:31 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9969545602798462,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "075a3d40-ece6-4c7d-96fc-4e6870d6f677",
                          "match_confidence": 0.9836031198501587,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "869a848a-6bce-44d4-b113-4e8484336308"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:29 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "43adec41-2f89-4b0b-a00a-c01de3611f58",
                          "match_confidence": 0.1620941013097763,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "43adec41-2f89-4b0b-a00a-c01de3611f58",
                          "match_confidence": 0.25759896636009216,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "b3ff0ef1-c672-4c6f-abf3-87359921c52d"
              },
              {
                  "camera_description": "West-2: Entering fire-doors Right Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:28 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "2f7e757a-56bc-4483-aac7-d79364e5e723",
                          "match_confidence": 0.17509062588214874,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "4265700a-e560-41ab-8cda-075b72a64ee3",
                          "match_confidence": 0.2801606059074402,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "9979dd34-fec2-4b82-a6e9-15c0ac3fbd61"
              },
              {
                  "camera_description": "Franklin:  Exiting from Back Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:22 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7ebfbdd2-bf91-43b3-82a5-4f5b7bcacd0a",
                          "match_confidence": 0.9910146594047546,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7ebfbdd2-bf91-43b3-82a5-4f5b7bcacd0a",
                          "match_confidence": 0.973055362701416,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "5ec587ec-1d49-4eff-a405-52f59cfb8822"
              },
              {
                  "camera_description": "Franklin:  Exiting from Back Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:21 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "fb786211-614c-47da-916f-363769e9ab32",
                          "match_confidence": 0.31374841928482056,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "fb786211-614c-47da-916f-363769e9ab32",
                          "match_confidence": 0.2288600206375122,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "f28c3dc3-5404-4000-8364-b71c9465bde2"
              },
              {
                  "camera_description": "Franklin:  Exiting from Back Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:20 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7ebfbdd2-bf91-43b3-82a5-4f5b7bcacd0a",
                          "match_confidence": 0.9986153841018677,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7ebfbdd2-bf91-43b3-82a5-4f5b7bcacd0a",
                          "match_confidence": 0.9631861448287964,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "f23cfc40-90f5-45a5-bdda-fa82a3d9880b"
              },
              {
                  "camera_description": "Franklin:  Exiting from Back Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:19 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "40677570-302f-4b8c-9828-2215fcbb3b92",
                          "match_confidence": 0.9570385217666626,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "793a3788-32c0-41a6-b800-e371640f22a9",
                          "match_confidence": 0.9217527508735657,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "96ae46f3-79eb-413c-a4b0-18f7e54d97eb"
              },
              {
                  "camera_description": "Franklin:  Exiting from Back Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:18 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "793a3788-32c0-41a6-b800-e371640f22a9",
                          "match_confidence": 0.540775716304779,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "793a3788-32c0-41a6-b800-e371640f22a9",
                          "match_confidence": 0.8127076029777527,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "39b7f01a-5350-4c79-9d26-f7012d76a9f7"
              },
              {
                  "camera_description": "Franklin:  Exiting from Back Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:17 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "a3d3df75-8e4e-4dd9-a7d9-22a47c84bf7c",
                          "match_confidence": 0.948306679725647,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "a3d3df75-8e4e-4dd9-a7d9-22a47c84bf7c",
                          "match_confidence": 0.7869367003440857,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "1483dfe1-44fb-4b72-a22c-d40abf967819"
              },
              {
                  "camera_description": "Franklin:  Exiting from Back Hallway",
                  "captured_at": "Wed, 07 Feb 2018 05:03:16 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": "7ebfbdd2-bf91-43b3-82a5-4f5b7bcacd0a",
                          "match_confidence": 0.9160791039466858,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "7ebfbdd2-bf91-43b3-82a5-4f5b7bcacd0a",
                          "match_confidence": 0.48155924677848816,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "431f6b62-c36d-44b4-92f4-adf914339ce1"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:03:15 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.3918358087539673,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "d7b9bdb4-dd8c-4fa1-aa4a-b6f5cb77c7eb",
                          "match_confidence": 0.3588588237762451,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "7b956efb-72fa-48ca-bccf-9f7527834c9a"
              },
              {
                  "camera_description": "West-1: Coventry Kitchen",
                  "captured_at": "Wed, 07 Feb 2018 05:03:15 GMT",
                  "predictions": [
                      {
                          "frontend_face_uuid": null,
                          "match_confidence": 0.8162192106246948,
                          "model_name": "feb1_exp0/v0"
                      },
                      {
                          "frontend_face_uuid": "5a0c8bb1-b63e-4ec5-890a-87191dacf505",
                          "match_confidence": 0.30366286635398865,
                          "model_name": "feb5_exp3/v2"
                      }
                  ],
                  "runtime_face_uuid": "9b9a1d85-26d2-4145-be91-92c622c9f902"
              }
          ]
      }
      }
      resolve(toret);
    })
  }
  const model_names = model_list.join(',')
  return getRequest('/api/v6/faces/training/results', 'models=' + model_names + (store.getters.domainUUID ? '&domain_uuid=' + store.getters.domainUUID : ''))
}

export function facesmatchingtags(runtime_face_uuid) {
   return getRequest('/api/v6/faces/tags/matching/' + runtime_face_uuid);
}

export function facesrecent() {
   return getRequest('/api/v6/faces/recent');
}

export function facesssim() {
   return getRequest('/api/v6/faces/ssim');
}

export function facewrongshape(runtime_face_uuid) {
  return makeRequest('/api/v6/faces/confirmed/wrong_shape/' + runtime_face_uuid, {});
}

export function facesclahe(model='live') {
  let req_str = `model=${model}` ;
  const min_face_height = store.getters.minFaceHeight
  const domain_uuid = store.getters.domainUUID
  if (min_face_height) {
    req_str += `&min_face_height=${min_face_height}`
  }
  if (domain_uuid) {
    req_str += `&domain_uuid=${domain_uuid}`
  }
  req_str += '&limit=20'
  return getRequest('/api/v6/faces/training/clahe/results', req_str);
}


// WEBPACK FOOTER //
// ./src/api/faces.js